import { render, staticRenderFns } from "./EditSendOrder.vue?vue&type=template&id=d3aba928&"
import script from "./EditSendOrder.vue?vue&type=script&lang=js&"
export * from "./EditSendOrder.vue?vue&type=script&lang=js&"
import style0 from "./EditSendOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports